import React from "react"
import { Toolbar, ToolbarGroup } from "material-ui"
import ExpandCollapseIcon from "material-ui/svg-icons/action/reorder"
import IconButton from "material-ui/IconButton"
import GlobalFilterHierarchyNavItem from "./GlobalFilterHierarchyNavItem"
import UserProfileDialog from "../../pages/users/UserProfileDialog"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AppStateStore from "../../stores/AppStateStore"
import autobind from "class-autobind"
import LiveProgress from "../../components/misc/LiveProgress"
import { ELoggedInUserType } from "../../models"
import Notifications from "./Notifications"
import AppSwitchMenu from "./AppSwitchMenu"
import AccountStore from "../../stores/AccountStore"
interface IProps {
    loggedInUserType: ELoggedInUserType
    onLogoutClick(): void
}
interface IState {
    expand: string
    showNav: boolean
    showMenu: boolean
}


export default class Header extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            expand: AppStateStore.getExpandNav(),
            showNav: AuthenticationStore.isLoggedIn(),
            showMenu: true
        }
        autobind(this)
    }

    componentDidMount() {
        AuthenticationStore.on("change", this.changeEvent)
        AppStateStore.on("change", this.changeEvent)
    }

    componentWillUnmount() {
        AuthenticationStore.removeListener("change", this.changeEvent)
        AppStateStore.removeListener("change", this.changeEvent)
    }

    toggleLeftNav() {
        AppStateStore.toggleLeftNav()
    }

    changeEvent() {
        this.setState({
            showNav: AuthenticationStore.isLoggedIn(),
            expand: AppStateStore.getExpandNav()
        })
    }

    render() {
        let styles = {
            logoExpand: {
                width: 80,
                padding: 0
            },
            logoCollapse: {
                width: 40,
                marginLeft: -3,
                padding: 0
            },
            expand: {
                left: 250
            },
            collapse: {
                left: 80
            },
            logoContainerExpand: {
                width: 224,
                backgroundColor: AppStateStore.getFrontEndSettings().UISettings.HeaderSecondaryColor,
                height: "100%"
            },
            logoContainerCollapse: {
                width: 80,
                backgroundColor: AppStateStore.getFrontEndSettings().UISettings.HeaderSecondaryColor,
                height: "100%"
            }
        }

        return (
            <div className="Header">
                {this.state.showNav &&
                    <Toolbar style={{ height: this.state.showMenu ? 70 : 10, backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuBarBackgroundColor, padding: "0px 15px 0 24px" }}>
                        <ToolbarGroup firstChild>
                            {this.state.showMenu && this.state.expand === "expanded" ?
                                <div style={styles.logoContainerExpand}>
                                    <img className="nav-logo" src={AppStateStore.getFrontEndSettings().UISettings.HeaderLogoURL} style={styles.logoExpand} />
                                </div> :
                                <div style={styles.logoContainerCollapse}>
                                    <img className="nav-logo" src={AppStateStore.getFrontEndSettings().UISettings.HeaderCollapsedLogoURL} style={styles.logoCollapse} />
                                </div>
                            }
                        </ToolbarGroup>
                        <div className="expand-collapse-icon" style={this.state.expand === "expanded" ? styles.expand : styles.collapse} onClick={this.toggleLeftNav}>
                            <IconButton iconStyle={{ color: "white", width: 28, height: 28 }}>
                                <ExpandCollapseIcon />
                            </IconButton>
                        </div>
                        {this.state.showMenu &&
                            <ToolbarGroup style={{ color: AppStateStore.getFrontEndSettings().UISettings.HeaderTextColor, paddingTop: 12, cursor: "pointer", display: "block" }}>
                                <div className="hierarchy-nav-item" style={{ float: "right", paddingLeft: 55, display: "flex" }}>
                                    <GlobalFilterHierarchyNavItem loggedInUserType={this.props.loggedInUserType} />
                                    {AccountStore.getHREnabled() &&
                                        <AppSwitchMenu />
                                    }
                                    {AccountStore.getScheduleEnabled() &&
                                        <Notifications />
                                    }
                                </div>
                                <div style={{ clear: "both" }} />
                            </ToolbarGroup>
                        }
                    </Toolbar>
                }
                <UserProfileDialog />
                <LiveProgress />
            </div>
        )
    }
}